module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "loader",
    class: _vm.overlayClass
  }, [_c('div', {
    staticClass: "content",
    class: _vm.classContent
  }, [_c('pulse-loader', {
    style: (_vm.loaderStyle),
    attrs: {
      "loading": _vm.loading,
      "color": _vm.color,
      "size": _vm.size
    }
  }), _vm._v(" "), (_vm.label) ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f199594","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Loader.vue
// module id = 3278
// module chunks = 0